@if (cardInfo(); as cardInfo) {
  <div>
    <crm-collapsible-section [maxHeightPx]="100">
      <crm-activity-rich-text [richText]="cardInfo.note"></crm-activity-rich-text>
    </crm-collapsible-section>
    @if (callRecordingSource$ | async; as callUrl) {
      <audio class="activity-data-call-recording" preload="metadata" controls src="{{ callUrl }}">
        Audio playback is not supported
      </audio>
    }
    <div class="row">
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.LOGGED_CALL.DIRECTION', value: cardInfo.direction }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.LOGGED_CALL.STATUS', value: cardInfo.status }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.LOGGED_CALL.OUTCOME', value: cardInfo.outcome }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.DATE', value: cardInfo.date | date: dateFormat }"
      ></ng-container>
    </div>
  </div>
}

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-3">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      @if (value) {
        {{ value }}
      }
    </div>
  </div>
</ng-template>
